import { render, staticRenderFns } from "./SetActive.vue?vue&type=template&id=c28db52a&"
import script from "./SetActive.vue?vue&type=script&lang=js&"
export * from "./SetActive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c28db52a')) {
      api.createRecord('c28db52a', component.options)
    } else {
      api.reload('c28db52a', component.options)
    }
    module.hot.accept("./SetActive.vue?vue&type=template&id=c28db52a&", function () {
      api.rerender('c28db52a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OperationWorkbench/SetActive.vue"
export default component.exports